import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { addExpenseTypesApi } from "./Expense.action";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddExpenseTypes = (props) => {
  const [expenseName, setExpenseName] = useState();
  const [expenseDesc, setExpenseDesc] = useState();


  function uploadExpenseType() {
    props.addExpenseTypesApi(
      {
        expenseName: expenseName,
        expenseDesc: expenseDesc,
      },
      showSuccessAlert,
      showErrorAlert,
    );
    setExpenseName("");
    setExpenseDesc("");
  }

  useEffect(() => {
    props.setHeading("Add Expense Types");
  }, []);

  return (
    <>
      {props.isAddingExpenseType ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Form>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Expense Name *</b></Form.Label>
                  <Form.Control
                    value={expenseName}
                    type="text"
                    placeholder="Expense Name"
                    onChange={(e) => setExpenseName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col lg="6" md="6" xs="6">
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Expense Description </b></Form.Label>
                  <Form.Control
                    type="text"
                    value={expenseDesc}
                    placeholder="Expense Description"
                    onChange={(e) => setExpenseDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="sendDiv">
              {_.isEmpty(expenseName) ? (
                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
              ) : (
                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadExpenseType}> SAVE </Button>
              )}
            </div>

          </Form>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addExpenseTypesApi: (data, showSuccessAlert, showErrorAlert) => dispatch(addExpenseTypesApi(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingExpenseType: state.ExpenseTypeReducer.isAddingExpenseType,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddExpenseTypes);
